/**
 * format.js — pure value formatters with no React or DOM dependency.
 *
 * Deliberately separate from components/shared.js: validate.js needs
 * formatBytes for its 402 message, and shared.js pulls in React, react-dom
 * and the palette constants. Keeping this a leaf module avoids that weight.
 */

// Storage quotas are stated in MB by the plan; the backend counts raw bytes.
// This assumes binary MB (1024²) — see the note in formatBytes.
export const BYTES_PER_MB = 1024 * 1024;

/** Plan quota (MB) → bytes, for comparing against storageUsedBytes. */
export const mbToBytes = (mb) => (mb == null ? null : Number(mb) * BYTES_PER_MB);

/**
 * Human-readable byte size for storage quotas.
 *
 * Keeps two decimals below 10 MB on purpose: a 600 KB upload against a 1 MB
 * plan has to read "0.59 MB", not "0 MB". Integer division there makes the
 * meter look broken to the very user whose next upload is about to be
 * rejected for being over quota.
 */
export function formatBytes(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return '0 MB';

  const GB = 1024 * BYTES_PER_MB;
  if (n >= GB)                return `${(n / GB).toFixed(2)} GB`;
  if (n >= 10 * BYTES_PER_MB) return `${(n / BYTES_PER_MB).toFixed(1)} MB`;
  return `${(n / BYTES_PER_MB).toFixed(2)} MB`;
}
